import React from 'react';

export const Services = (props) => {
  return (
    <div
      id='services'
      className='text-center'
    >
      <div className='container'>
        <div className='section-title'>
          <h2>Our Packages</h2>
          <p>
            At Piegon's Communication, we understand that everyone's internet
            needs are unique. That's why we offer a range of thoughtfully
            crafted internet service packages that cater to various online
            activities and preferences. No matter if you're a casual surfer or a
            heavy-duty streamer, we have the perfect package for you. Explore
            our packages below:
          </p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className='col-md-4'
                >
                  {' '}
                  <i className={d.icon}></i>
                  <div
                    className='service-desc'
                    style={{ textAlign: 'start' }}
                  >
                    <h3>{d.name}</h3>
                    <p>
                      Speed:{' '}
                      <span style={{ fontWeight: 'bold', color: 'white' }}>
                        {d.text}
                      </span>
                    </p>
                    <p>
                      Usage:{' '}
                      <span style={{ fontWeight: 'bold', color: 'white' }}>
                        {d.desc}
                      </span>
                    </p>
                    <ul>
                      {d.list.map((item) => {
                        return (
                          <li
                            key={item}
                            style={{
                              listStyleType: 'initial',
                              textAlign: 'start',
                            }}
                          >
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  );
};
